'use client'
import React from 'react'

export const BlockIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="4" rx="0.5" stroke="currentColor" width="4" x="8" y="5" />
    <rect height="4" rx="0.5" stroke="currentColor" width="4" x="5" y="11" />
    <rect height="4" rx="0.5" stroke="currentColor" width="4" x="11" y="11" />
  </svg>
)
